/**
 * A Pinned tile's cell and body (mockup `.prow > .card`): one column of the
 * Pinned grid, the card's soft shadow with no edge and its hover outline,
 * the type the tile's em sizes read. Frame tiles (`wall-tool-tile.tsx`) and
 * the tiles that are not frames (chats, the quick note) share it. The cell
 * takes the pointer on the desktop.
 */
import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { WALL_HOVER_OUTLINE_CLASS } from "./wall-card";

export const WALL_TILE_CELL_CLASS = "group/wall-item relative min-h-0 min-w-0";

export const WALL_TILE_BODY_CLASS = cn(
  "relative h-full w-full overflow-hidden rounded-card shadow-card-wall [font-size:var(--wall-fs,13px)]",
  WALL_HOVER_OUTLINE_CLASS,
);

/** A Pinned tile that is not a frame: the chats list or the quick note. */
export function WallPinTile({
  pin,
  label,
  bodyClassName,
  children,
}: {
  pin: "chats" | "note";
  label: string;
  bodyClassName?: string;
  children: ReactNode;
}) {
  return (
    <section
      className={WALL_TILE_CELL_CLASS}
      aria-label={label}
      data-interactive="true"
      data-wall-tile=""
      data-pin={pin}
      data-testid={`wall-pin-${pin}`}
    >
      <div className={cn(WALL_TILE_BODY_CLASS, bodyClassName)}>
        {/* The frames' solid paper, as in a frame tile: the text tokens
            the shared rows use read the card ink. */}
        <div className="denker-solid-frame flex h-full w-full flex-col">
          {children}
        </div>
      </div>
    </section>
  );
}
